import Model from '../index'

class Common extends Model {
  // 获取腾讯阿里云相关参数
  getOssConfig (options = {}) {
    options.url = '/api/app/common/getEnvMigrationVO'
    return this.get(options)
  }

  // 获取 oss 参数
  getOssSecurityToken (options = {}) {
    options.url = '/api/app/aliCommon/getOssSecurityToken'
    return this.post(options)
  }

  // 刷新 oss 参数
  refreshOssSecurityToken (options = {}) {
    options.url = '/api/app/aliCommon/refreshOssSecurityToken'
    return this.post(options)
  }

  // 获取微信签名
  getTicket (options = {}) {
    options.url = '/api/app/wechat/getTicket'
    return this.post(options)
  }

  // 验证401
  verify401 (options = {}) {
    options.url = '/api/app/common/getFunctionIntroduction'
    return this.post(options)
  }

  // 医院下拉列表接口(支持分页,模糊匹配医院名称
  getHospitalSelectVOPageList (options = {}) {
    options.url = '/api/app/common/getHospitalSelectVOPageList'
    return this.post(options)
  }

  // 科室下拉列表接口(支持分页,模糊匹配科室名称
  getDepartmentSelectVOPageList (options = {}) {
    options.url = '/api/app/common/getDepartmentSelectVOPageList'
    return this.post(options)
  }

  // 职称下拉列表接口(支持分页,模糊匹配职称名称)
  getTitleSelectVOPageList (options = {}) {
    options.url = '/api/app/common/getTitleSelectVOPageList'
    return this.post(options)
  }

  // 下拉选择字典科室(支持分页,模糊匹配名称)
  getDictionaryDepartmentVOPageList (options = {}) {
    options.url = '/api/app/common/getDictionaryDepartmentVOPageList'
    return this.post(options)
  }

  // 获取加密code
  getEncodeCode (options = {}) {
    options.url = '/api/app/common/getEncodeCode'
    return this.post(options)
  }

  // 查询热图详情
  getHeatMapInfo (options = {}) {
    options.url = '/api/app/common/getHeatMapInfo'
    return this.post(options)
  }

  // 解析内链接口
  parseShortLinkBatch (options = {}) {
    options.url =  `/api/app/common/shortlink/parse?shortLinks=${options.shortLinks}`
    return this.get(options)
  }

  // 全部活动
  getAllHomePageActivityPageList (options = {}) {
    options.url = '/api/app/common/getAllHomePageActivityPageList'
    return this.post(options)
  }

  // 获取资源解锁实际扣除积分
  getActualPayPoint (options = {}) {
    options.url = '/api/app/common/getActualPayPoint'
    return this.post(options)
  }

  // 查询个人信息
  getAccountInfoById (options = {}) {
    options.url = '/api/app/common/getAccountInfoById'
    return this.post(options)
  }

  getMyUserInfo (options = {}) {
    options.url = '/api/app/login/getMyUserInfo'
    return this.post(options)
  }

  getUserFollowWX (options = {}) {
    options.url = '/api/app/action/verdictUserFollowWX'
    return this.get(options)
  }

  getQR (options = {}) {
    options.url = '/api/app/wechat/getQR'
    return this.post(options)
  }

  // 获取全量术士
  getAllOperationMode (options = {}) {
    options.url = '/api/app/common/getAllOperationMode'
    return this.post(options)
  }

  getUserPartner (options = {}) {
    options.url = '/api/app/doctor-partner/queryUserPartner'
    return this.post(options)
  }

  getUserFocusList (options = {}) {
    options.url = '/api/app/doctor-partner/queryUserFocusList'
    return this.post(options)
  }

  queryGuessRecommendList (options = {}) {
    options.url = '/api/app/doctor-partner/queryGuessRecommendList'
    return this.post(options)
  }

  batchFocusOrCancel (options = {}) {
    options.url = '/api/app/doctor-partner/batchFocusOrCancel'
    return this.post(options)
  }

  checkTokenValid (options = {}) {
    options.url = '/api/app/common/checkTokenValid'
    return this.get(options)
  }

  queryDoctorSecondTitle (options = {}) {
    options.url = '/api/app/common/queryDoctorSecondTitle'
    return this.get(options)
  }

  queryFdf2Img (options = {}) {
    options.url = `/api/live/app/web/common/queryFdf2Img?pdfUrl=${options.pdfUrl}`
    return this.get(options)
  }

  // 获取枚举值列表
  queryTagList (options = {}) {
    options.url = '/api/app/bmTag/queryTagList'
    return this.post(options)
  }

  // 获取枚举值列表树
  queryTagTreeList (options = {}) {
    options.url = '/api/app/bmTag/queryTagTreeList'
    return this.post(options) 
  }

}

const commonModel = new Common()
export default commonModel
